import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Redux } from '../..'
import { GygQueryOptions } from '@/src/views/components/master-pricing-list/types'
import { GygGroup } from '@/src/types/apps/gygGroups'

interface GroupInitialState {
  groups?: GygGroup[] | null
  loading: boolean
  success: string | null
  error: string | null
}

const initialState: GroupInitialState = {
  groups: null,
  loading: false,
  success: null,
  error: null
}

interface GroupsResponse {
  data: GygGroup[]
}

export const getGroups = createAsyncThunk<GroupsResponse, GygQueryOptions, Redux>(
  'gygGroups/getAllGroups',
  async (gygQueryOptions, { extra }) => {
    const { data: responseData } = await extra.httpClient.get(`groups`, { params: gygQueryOptions })

    return responseData
  }
)

const gygGroupSlice = createSlice({
  name: 'getAllGroups',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getGroups.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getGroups.fulfilled, (state, action) => {
        state.loading = false
        state.success = null
        state.groups = action.payload.data
      })
      .addCase(getGroups.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to fetch menu templates'
      })
  }
})

export default gygGroupSlice.reducer
